import { modelServices } from '@/app/shared/services/client-agent-service.js';
import { httpClient } from '@/app/shared/services/http-client/http-client.js';
// import { httpClient } from '@/app/shared/services/http-client/http-client.js';

export class PatientSearchService {
 
GetPatientSearchOdataList="";
    constructor() {
          
       this.GetPatientSearchOdataList = modelServices.baseUrl + modelServices.getMPIOdataServiceName("QuickFindPatient").URL;
        //this.GetBloodBankOdataList = modelServices.baseUrl + modelServices.getBloodBankOdataServiceName("BloodBankOdataList").URL;
   
    }

    GetPatientByCode(patientCode,callback, errCallback) {
        let service = modelServices.getMPIOdataServiceName("QuickFindPatient");
    
        var options = {
            method: service.Method,
            url: modelServices.baseUrl + service.URL,
            params: {
                searchKey: '',
                Code: decodeURIComponent(patientCode)
            }
        };
    
        httpClient(options).then(callback).catch(errCallback);
    }
    // GetJournalFilters(callback, errCallback) {
    //     httpClient.get(modelServices.baseUrl + modelServices.getFinanceServiceName("GetJournalEntryFilters").URL).then(callback).catch(errCallback);
    // }
}



const patientSearchService = new PatientSearchService();

export { patientSearchService };